import config from "./../config/config";
import JSEncrypt from "jsencrypt/bin/jsencrypt.min.js";

let accessToken = null;

export const API_ROOT = config.get("API_ROOT_URL");
export const API_PROXY_URL = config.get("API_PROXY_URL");

const fetchOptions = (body, method) => {
  let authHeader = {};
  let context = JSON.parse(sessionStorage.getItem("context"));
  let accessToken;
  let session;

  if (context) {
    accessToken = context.accessToken;
    session = context.session;
  }
  let guid;
  if (session) {
    guid = session.UserGUID;
  }

  if (accessToken) {
    authHeader = { Authorization: `${accessToken}` };
  }

  const options = {
    device: `Platform: ${navigator.platform}, User Agent: ${navigator.userAgent}, App Version: ${navigator.appVersion}, Vendor: ${navigator.vendor}`,
    path: location.href,
    guid,
  };

  return {
    method,
    headers: {
      Accept: "application/json",
      Authorization: getAccessToken(),
      "Content-Type": "application/json; charset=utf-8",
      ...authHeader,
      ClientOptions: JSON.stringify(options),
    },
    credentials: "include",
    body: body ? JSON.stringify(body) : undefined,
  };
};

export function callApiProxy(service, body) {
  if (!accessToken) {
    const contextJSON = sessionStorage.getItem("context");
    if (contextJSON) {
      accessToken = JSON.parse(contextJSON).accessToken;
    }
  }

  return fetch(`${API_PROXY_URL}${service}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `OAuth ${getAccessToken()}`,
    },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .catch((e) => console.error(e.toString()));
}

export function callApi(endpoint, body = undefined, method = "POST", normalizeFunction = (a) => a) {
  const fullUrl = endpoint.indexOf(API_ROOT) === -1 ? API_ROOT + endpoint : endpoint;
  const options = fetchOptions(body, method);

  return fetch(fullUrl, options)
    .then((response) => {
      if (response.status == 401) {
        return Promise.reject({ unauthorized: true });
      }
      return response.json().then((json) => {
        if (json.error === "Session expired" || json.error === "La sesión ha expirado") {
          sessionStorage.clear();
          window.location.reload();
          return;
        }
        return { json, response };
      });
    })
    .then(({ json, response }) => {
      if (!response.ok) {
        return Promise.reject(json);
      }

      return normalizeFunction(json);
    })
    .then(
      (response) => ({ response }),
      (error) => error || { error: "Something bad happened" }
    );
}

export function callApiProxyCallback(service, body, callback) {
  return fetch(`${API_PROXY_URL}${service}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `OAuth ${getAccessToken()}`,
    },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.code && data.code !== 0) {
        alert(data.message);
        callback(null, data.message);
      } else {
        callback(data);
      }
    })
    .catch((e) => callback(null, e.toString()));
}

export function getAccessToken() {
  if (!window.API_TOKEN) {
    const contextJSON = sessionStorage.getItem("context");
    if (contextJSON) {
      window.API_TOKEN = JSON.parse(contextJSON).accessToken;
    }
  }

  return window.API_TOKEN;
}

export const preLogin = (credentials) => {
  const encrypt = new JSEncrypt();

  return callApi("user/preLogin", null, "GET").then(({ response }) => {
    const publicKey = window.atob(response.publicKey);
    encrypt.setPublicKey(publicKey);
    credentials.password = encrypt.encrypt(credentials.password);
    credentials.publicKey = response.publicKey;

    return credentials;
  });
};

export const preAuthService = (credentials) =>
  callApi("user/preExternalLogin", { ...credentials, version: 2 }, "POST");

export const authService = (credentials) => {
  const encrypt = new JSEncrypt();

  return callApi("user/preLogin", null, "GET").then(({ response }) => {
    const publicKey = window.atob(response.publicKey);
    encrypt.setPublicKey(publicKey);
    credentials.password = encrypt.encrypt(credentials.password);
    return callApi(
      "user/externalLogin",
      { ...credentials, version: 2, publicKey: response.publicKey },
      "POST"
    );
  });
};

export const logoutService = () => {
  return callApi("user/logout", null, "POST");
};

export const getCurrentVersion = (payload) => callApi("getFrontendVersion", { ...payload }, "POST");
